// The email/SMS consent built by App\Services\ConsentCopy names the button that gives it
// ("By clicking 'Next', you consent..."). The server cannot know which button a step shows --
// a form's last step says "Submit" -- so ConsentCopy wraps the name in this marker and the form
// swaps in the label the step actually shows. Left unreplaced, the marker still reads "Next".
const CONSENT_BUTTON_MARKER = /(<span data-consent-button>)[^<]*(<\/span>)/g;

function escapeHtml(text) {
    return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function withConsentButtonLabel(html, label) {
    if (!html || !label) {
        return html;
    }

    return html.replace(CONSENT_BUTTON_MARKER, (match, open, close) => open + escapeHtml(label) + close);
}

export { withConsentButtonLabel };
